import React from 'react'
import PropTypes from 'prop-types'
import {ListName} from "../../constant/convertFilter"

DetailSearch.propTypes = {
    filters: PropTypes.object.isRequired
}

function DetailSearch(props) {
    const {filters} = props
    const {
        status,
        level,
        name,
        partner,
        user_create,
        sewing_time_type,
        sewing_partner,
        created_at,
        sewing_at,
        printed_overtime,
        sewing_overtime,
        transferred_overtime,
        product_types
    } = filters

    function _getName(value) {
        const list = ListName.find(item => item.value === value)

        return list.name
    }

    function _checkOverTime(value) {
        if (!!value.from && !value.to && value.phase_status === 'completed') {
            return _getName('yy')
        } else if (!!value.from && !value.to && value.phase_status === 'not_completed') {
            return _getName('yn')
        } else if (!!value.from && !value.to && !value.phase_status) {
            return _getName('y')
        } else if (!value.from && !!value.to && !value.phase_status) {
            return _getName('n')
        } else {
            return `Từ ${value.from} giờ đến ${value.to} giờ`
        }
    }

    return (
        <div className="Details">
            <ul>
                <li>Trạng thái lô: <span>{status || 'Tất cả'}</span></li>

                <li>Tên lô: <span>{name || 'Tất cả'}</span></li>

                <li>Người tạo lô: <span>{user_create || 'Tất cả'}</span></li>

                <li>
                    Ngày tạo
                    lô: <span>{!!created_at ? `Từ ngày ${created_at.from} đến ngày ${created_at.to}` : 'Tất cả'}</span>
                </li>

                <li>
                    Ngày giao
                    may: <span>{!!sewing_at ? `Từ ngày ${sewing_at.from} đến ngày ${sewing_at.to}` : 'Tất cả'}</span>
                </li>

                <li>Đối tác in ép: <span>{partner || 'Tất cả'}</span></li>

                <li>Đối tác may: <span>{sewing_partner || 'Tất cả'}</span></li>

                <li>Độ ưu tiên: <span>{!!level ? _getName(level) : 'Tất cả'}</span></li>

                <li>
                    Ngày nhận may: <span>{!!sewing_time_type ? _getName(sewing_time_type) : 'Tất cả'}</span>
                </li>

                <li>
                    Thời gian quá hạn
                    in: <span>{!!printed_overtime ? _checkOverTime(printed_overtime) : 'Tất cả'}</span>
                </li>

                <li>
                    Thời gian quá hạn
                    ép: <span>{!!transferred_overtime ? _checkOverTime(transferred_overtime) : 'Tất cả'}</span>
                </li>

                <li>
                    Thời gian quá hạn
                    may: <span>{!!sewing_overtime ? _checkOverTime(sewing_overtime) : 'Tất cả'}</span>
                </li>

                <li className='productType'>Loại sản
                    phẩm: <span>{!!product_types ? product_types.toString() : 'Tất cả'}</span></li>
            </ul>
        </div>
    )
}

export default DetailSearch
